import { Paragraph } from "@digdir/designsystemet-react";
import type { ReactNode } from "react";
import type { ReportDetailField } from "../../data/types";
import { RapportkatalogCardDescription } from "./RapportkatalogCardDescription";
import "./RapportkatalogCardDetails.css";

type RapportkatalogCardDetailsProps = {
    detailFields: ReportDetailField[];
    renderDetailValue: (value: string, label?: string) => ReactNode;
};

export function RapportkatalogCardDetails({ detailFields, renderDetailValue }: RapportkatalogCardDetailsProps) {
    if (detailFields.length === 0) {
        return <Paragraph data-size="sm">Ingen flere felter registrert.</Paragraph>;
    }

    return (
        <details className="rapportkatalog-card-details">
            <summary>
                <span className="rapportkatalog-card-details-chevron" aria-hidden="true">
                    ›
                </span>
                <span className="rapportkatalog-card-details-summary-text rapportkatalog-card-details-summary-text-open">
                    Se færre detaljer
                </span>
                <span className="rapportkatalog-card-details-summary-text rapportkatalog-card-details-summary-text-closed">
                    Se flere detaljer
                </span>
            </summary>

            <div className="rapportkatalog-card-details-content">
                {detailFields.map((field) => (
                    <RapportkatalogCardDescription
                        key={field.label}
                        label={field.label}
                        text={renderDetailValue(field.value, field.label)}
                    />
                ))}
            </div>
        </details>
    );
}
